import { render } from "./LeaveListTableHeader.vue?vue&type=template&id=02dea898&scoped=true"
import script from "./LeaveListTableHeader.vue?vue&type=script&lang=js"
export * from "./LeaveListTableHeader.vue?vue&type=script&lang=js"

import "./LeaveListTableHeader.vue?vue&type=style&index=0&id=02dea898&lang=scss&scoped=true"

import exportComponent from "/Users/oscarbout/Code/3birdhrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02dea898"]])

export default __exports__